// "Order again": rebuild cart lines from a previous order using the CURRENT
// menu/combo configuration (prices are always recomputed by the cart).
// Anything that can no longer be ordered is reported, never silently dropped.
import { getProductById } from "@/data/menu";
import { getComboById } from "@/data/combos";
import { sanitizeSelections } from "@/lib/format";

function comboOrderable(combo) {
  return !!combo && combo.available && combo.componentIds.every((id) => getProductById(id)?.available);
}

// Returns { lines: CartLinePayload[], skipped: { kind: "product"|"combo", name }[] }.
export function buildReorder(order) {
  const lines = [];
  const skipped = [];

  (order?.items || []).forEach((it) => {
    if (it.isCombo || !it.productId) {
      const combo = it.comboId ? getComboById(it.comboId) : null;
      if (comboOrderable(combo)) {
        lines.push({ comboId: combo.id, isCombo: true, quantity: it.quantity, selections: {}, note: "" });
      } else {
        skipped.push({ kind: "combo", name: combo?.name || it.name });
      }
      return;
    }
    const product = getProductById(it.productId);
    if (product && product.available) {
      lines.push({
        productId: product.id,
        quantity: it.quantity,
        selections: sanitizeSelections(product, it.selections || {}),
        note: it.note || "",
      });
    } else {
      skipped.push({ kind: "product", name: product?.name || it.name });
    }
  });

  return { lines, skipped };
}
